import { array } from 'fp-ts';
import { BillingSearchForReservationsForLinkingResult, ReservationLinkResult } from '@mews-commander/data-access';
import { EmptyReservationListItem } from './EmptyReservationListItem';
import { DividerReservationListItem } from './DividerReservationListItem';
import { renderReservationItem } from './renderReservationItem';

export const renderReservationList = (rs: BillingSearchForReservationsForLinkingResult, ownerId: string) => {
    const { left, right } = array.partition((i: ReservationLinkResult) => i.ownerId === ownerId)(rs);

    return [
        <EmptyReservationListItem />,
        <DividerReservationListItem resultCount={right.length} ownedReservations />,
        ...right.map((r: ReservationLinkResult) => renderReservationItem(r)),
        <DividerReservationListItem resultCount={left.length} ownedReservations={false} />,
        ...left.map((r: ReservationLinkResult) => renderReservationItem(r)),
    ];
};
